import { useState } from "react";
import { useNavigate } from "react-router-dom";

function HeaderSearchbar() {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query)}`);
    }
  };

  return (
    <li className="header-searchbar">
      <a
        aria-controls="offcanvasRight"
        className="d-block head-icon"
        data-bs-target="#offcanvasRight"
        data-bs-toggle="offcanvas"
        href="#"
        role="button"
      >
        <i className="iconoir-search"></i>
      </a>

      <div
        aria-labelledby="offcanvasRight"
        className="offcanvas offcanvas-end header-searchbar-canvas"
        id="offcanvasRight"
        tabIndex="-1"
      >
        <div className="header-searchbar-header">
          <div className="d-flex justify-content-between mb-3">
            {/* Search Form */}
            <form onSubmit={handleSearch} className="app-form app-icon-form w-100">
              <div className="position-relative">
                <input
                  aria-label="Search"
                  className="form-control search-filter"
                  placeholder="Search..."
                  type="search"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
                <i className="ti ti-search text-dark"></i>
              </div>
            </form>

            {/* Settings Dropdown */}
            <div className="app-dropdown flex-shrink-0">
              <a
                aria-expanded="false"
                className="h-35 w-35 d-flex-center b-r-15 overflow-hidden bg-light-secondary search-list-avtar ms-2"
                data-bs-auto-close="outside"
                data-bs-toggle="dropdown"
                href="#"
                role="button"
              >
                <i className="ph-duotone ph-gear f-s-20"></i>
              </a>
              <ul className="dropdown-menu mb-3">
                <li className="dropdown-item mt-2">
                  <a href="#">
                    <h6 className="mb-0">Search Settings</h6>
                  </a>
                </li>
                {/* switches can remain same */}
              </ul>
            </div>
          </div>

          <p className="mb-0 text-secondary f-s-15 mt-2">Recently Searched Data:</p>
        </div>

        {/* Recent Searches (dynamic list later) */}
        <div className="offcanvas-body app-scroll p-0">
          <ul className="search-list">
            <li className="search-list-item">
              <div className="h-35 w-35 d-flex-center b-r-15 overflow-hidden bg-light-primary search-list-avtar">
                <i className="ph-duotone ph-gear f-s-20"></i>
              </div>
              <div className="search-list-content">
                <a href="/api" target="_blank">
                  <h6 className="mb-0 text-dark">user management</h6>
                </a>
                <p className="f-s-13 mb-0 text-secondary">#RA789</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </li>
  );
}

export default HeaderSearchbar;
